import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ResultsSearchService } from '../home/results-search.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { TruncateModule } from 'ng2-truncate';
import { ItinerarySummaryComponent } from './itinerary-summary.component';
import { YourtripSummaryComponent } from './content-summary/yourtrip-summary/yourtrip-summary.component';
import { FlightComponent } from './content-summary/body-summary/flight/flight.component';
import { DestinySummaryComponent } from './content-summary/body-summary/destiny-summary/destiny-summary.component';
import { ItemRentacarComponent } from './content-summary/body-summary/destiny-summary/categories/item-rentacar/item-rentacar.component';
import { ItemToursComponent } from './content-summary/body-summary/destiny-summary/categories/item-tours/item-tours.component';
import { ItemDisneyComponent } from './content-summary/body-summary/destiny-summary/categories/item-disney/item-disney.component';
import { ItemHotelComponent } from './content-summary/body-summary/destiny-summary/categories/item-hotel/item-hotel.component';
import { ItemPthemesComponent } from './content-summary/body-summary/destiny-summary/categories/item-pthemes/item-pthemes.component';
import { ItemTransportComponent } from './content-summary/body-summary/destiny-summary/categories/item-transport/item-transport.component';
import { ItinerarySummaryRoutingModule } from './itinerary-summary-routing.module';
import { SuggestionsItemComponent } from './content-summary/body-summary/destiny-summary/categories/suggestions-item/suggestions-item.component';
import { ItemInsuranceComponent } from './content-summary/body-summary/destiny-summary/categories/item-insurance/item-insurance.component';
import { SuggestionByDateComponent } from './content-summary/body-summary/destiny-summary/categories/suggestion-by-date/suggestion-by-date.component';
import { DayFreeSkeletonComponent } from './content-summary/body-summary/destiny-summary/categories/day-free-skeleton/day-free-skeleton.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ResearchService } from '../shared/research.service';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from '../shared/shared.module';
import { BarRatingModule } from 'ngx-bar-rating';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

// import { OrderByPipe } from '../itinerary/itinerary.pipes';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ItinerarySummaryRoutingModule,
        NgxPaginationModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        BarRatingModule,
        BrowserAnimationsModule,
        FormsModule,
        TruncateModule,
        NgxSpinnerModule,
        SharedModule,
        TooltipModule
    ],
    declarations: [
        ItinerarySummaryComponent,
        YourtripSummaryComponent,
        FlightComponent,
        DestinySummaryComponent,
        ItemRentacarComponent,
        ItemToursComponent,
        ItemDisneyComponent,
        ItemHotelComponent,
        ItemPthemesComponent,
        ItemTransportComponent,
        SuggestionsItemComponent,
        ItemInsuranceComponent,
        SuggestionByDateComponent,
        DayFreeSkeletonComponent,
    ],
    exports: [
        ItinerarySummaryComponent
      ],

    providers: [
        ResultsSearchService,
        ResearchService,
        DatePipe
    ]
})
export class ItinerarySummaryModule { }
